// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "whatsapp_pending_connection".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "whatsapp_pending_connection" table (1:1 with a DB row, on the wire). */
export const whatsappPendingConnectionAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    initiatedById: z.string(),
    encryptedCredentials: z.string(),
    availableWabas: z.unknown(),
    availablePhoneNumbers: z.unknown(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=whatsappPendingConnection.js.map